import type {SectionKey} from './sections';

/** Как ищут сам сайт и редакцию: оба алфавита, аббревиатуры и издатель перевода, на котором основан наш */
export const BASE_KEYWORDS = [
	'D&D',
	'DnD',
	'dnd',
	'ДнД',
	'днд',
	'Dungeons & Dragons',
	'Подземелья и драконы',
	'5e',
	'5.5e',
	'D&D 2024',
	'пятая редакция',
	'Hobby World',
	'Hobby Games',
];

/** Синонимы разделов: официальный перевод, фанатские варианты и оригинал */
export const SECTION_KEYWORDS: Record<SectionKey, string[]> = {
	index: [],
	classes: ['Класс', 'Классы', 'Подкласс', 'Class', 'Subclass'],
	species: ['Вид', 'Виды', 'Раса', 'Расы', 'Species', 'Race', 'Specie'],
	origins: ['Предыстория', 'Предыстории', 'Происхождение', 'Origin', 'Background'],
	feats: ['Черта', 'Черты', 'Feat', 'Feats'],
	spells: ['Заклинание', 'Заклинания', 'Магия', 'Spell', 'Spells', 'Фокусы', 'Заговоры', 'Cantrip'],
	items: ['Предмет', 'Магический предмет', 'Снаряжение', 'Экипировка', 'Item', 'Magic item'],
	monsters: [
		'Чудовище',
		'Чудовища',
		'Монстр',
		'Бестиарий',
		'Блок параметров',
		'Параметры',
		'Статблок',
		'Monster',
		'Stat block',
	],
	books: ['Книга', 'Книги', 'Приключение', 'Модуль', 'Adventure', 'Book'],
	glossary: ['Глоссарий', 'Правила', 'Термин', 'Glossary', 'Rules'],
	names: ['Имена', 'Генератор имён', 'Случайные имена', 'Name generator', 'Фэнтези имена'],
	trans14to24: ['D&D 2014', 'Перевод терминов', 'Изменения 2024'],
};

/** База + синонимы раздела + своё; без пустых и повторов (без учёта регистра) */
export function buildKeywords(
	section: SectionKey | null,
	...extra: Array<string | null | undefined | false>
): string[] {
	const seen = new Set<string>();
	const result: string[] = [];
	for (const word of [...BASE_KEYWORDS, ...(section ? SECTION_KEYWORDS[section] : []), ...extra]) {
		const value = typeof word === 'string' ? word.trim() : '';
		if (!value || seen.has(value.toLowerCase())) continue;
		seen.add(value.toLowerCase());
		result.push(value);
	}
	return result;
}
